import { accessToken } from '@client/stores/authStore'

export * from './icons'

export function getTokenHeader(config: any) {
    const token = accessToken.value
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`
    }
    return config
}

export default {
    serverUrl: '/',
    languages: [
        { symbol: 'en', label: 'English', country: 'gb' },
        { symbol: 'de', label: 'Deutsch', country: 'de' },
        //{ symbol: 'es', label: 'Español', country: 'es' },
    ],
}
